import Vue from 'vue';
import ElementUI, { Loading } from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store';
import { queryUrl } from '@/utils/util';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI, {locale});
Vue.config.productionTip = false;

async function getUserInfo() {
  const { ticket, redirect_url, webview = '', open_type = 'shop' } = queryUrl(window.location.href);

  if (open_type === 'shop') {
    document.title = 'Gems Store';
  }

  const loading = Loading.service({
    fullscreen: true,
    customClass: 'text-loading',
    text: open_type === 'shop' ? 'Shop launching...': 'Loading...',
  });

  await store.dispatch('auth', {
    ticket,
    redirectURL: redirect_url,
    webview: Boolean(webview)
  });

  loading.close();
}

Promise.all([
  getUserInfo()
]).then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});
